export default __webpack_public_path__ + "6e94dfef4b400641de4bbb76edd87ebe.png";